import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GeographySelect',
  props: {
    value: { default: undefined },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: number[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: unknown, disabled: boolean };





const geographyIds = computed<number[]>(() => {
  if (!props.value) return []
  if (Array.isArray(props.value)) {
    if (props.value.length === 0) return []
    if (typeof props.value[0] === 'number') {
      return props.value as number[]
    }
    return (props.value as Array<{ id?: number | null }>)
      .map((item) => item?.id)
      .filter((id): id is number => typeof id === 'number')
  }
  return []
})

return { __sfc: true,props, emit, geographyIds }
}

})